<template>
  <div class="container">
    <router-link tag="div" to="/ES" :class="lang==='ES'?'animated tada':''">
      <img src="../assets/img/lang_es.png" />
      Español
    </router-link>
    <router-link tag="div" to="/EN" :class="lang==='EN'?'animated tada':''">
      <img src="../assets/img/lang_en.png" />
      English
    </router-link>
    <!-- <router-link tag="div" to="/DE" :class="lang==='DE'?'animated tada':''">
      <img src="../assets/img/lang_de.png" />
      Deutsch
    </router-link>-->
  </div>
</template>
<script>
export default {
  data () {
    return {
      lang: ''
    }
  },
  created () {
    this.checkLang()
  },
  methods: {
    checkLang () {
      let userLang = navigator.language || navigator.userLanguage
      if (userLang.substring(0, 2) == 'es') {
        this.lang = 'ES'
        // }else if (userLang.substring(0,2) == "de"){
        // this.lang="DE"
      } else {
        this.lang = 'EN'
      }

      setTimeout(() => {
        this.$router.push({
          path: '/' + this.lang
        })
      }, 1000)
    }
  }
}
</script>
<style scoped>
@import url("../assets/styles/animate.css");
.container {
  background: var(--light-blue);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.container div {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
}
img {
  width: 50px;
}
@media only screen and (min-width: 576px) {
  .container {
    flex-direction: row;
  }
}
</style>
